<template>
  <el-row>
    <!-- 项目名 -->
    <el-col :span="4">
      <div
        class="grid-content bg-purple"
        style="margin-left: 20%; text-align: left"
      >
        <span style="font-size: 20px">
          <router-link style="color: #333" to="/">
            <h4>{{ projectName }}</h4>
          </router-link>
        </span>
      </div>
    </el-col>
    <el-menu
      :default-active="activeMenu"
      class="menu-name"
      mode="horizontal"
      @select="handleSelect"
      router
      active-text-color="#1890FF"
    >
      <el-menu-item index="/"> 首页 </el-menu-item>
      <el-menu-item index="/test/d">求职干货 </el-menu-item>
      <el-menu-item index="/test/a">找工作 </el-menu-item>
      <el-menu-item index="/test/c">求职指南</el-menu-item>
    </el-menu>

    <!-- 登录/登出/用户信息 -->
    <!-- <el-col :span="3">
      <div
        class="grid-content bg-purple-light"
        style="
          height: 60px;
          line-height: 60px;
          text-align: right;
          margin-right: 12%;
        "
      >
        <router-link style="color: #ff0517" v-if="userData == null" to="/login">
          登录/注册</router-link
        >

        <span v-if="userData != null">
          <span>
            <img
              :src="userData.head"
              style="
                cursor: pointer;
                border-radius: 20px;
                height: 25px;
                width: 25px;
              "
          /></span>
          <span style="margin-right: 12%; margin-left: 3%">
            {{
              userData.nickname.length > 3
                ? userData.nickname.substring(0, 3) + "..."
                : userData.nickname
            }}
          </span>

          <span
            style="cursor: pointer; font-size: 12px; color: #ff0517"
            @click="exitLogin"
          >
            退出
          </span>
        </span>
      </div>
    </el-col> -->
  </el-row>
</template>

<script>
export default {
  name: "XjTop",
  data() {
    return {
      // 选中菜单
      activeIndex: "0",

      // 项目名
      projectName: "苏州准职信息科技有限公司",
      // 当前登录用户信息
      userData: null,
      // 功能集 (注意这里方向是从右到左)
      funData: [
        // {
        //     path: null,
        //     name: "相关文档",
        //     children: [
        //         {
        //             path: "/test/c",
        //             name: "本项目文档",
        //             children: null
        //         },
        //         {
        //             path: "/test/d",
        //             name: "作者信息",
        //             children: null
        //         },
        //     ]
        // },
        {
          path: "/",
          name: "首页",
          children: null,
          id: "0",
        },
        {
          path: "/test/d",
          name: " 求职干货",
          children: null,
          id: "1",
        },

        // {
        //   path: "/test/b",
        //   name: "企业专区",
        //   children: null,
        // },
        {
          path: "/test/a",
          name: "找工作",
          children: null,
          id: "2",
        },
        {
          path: "/test/c",
          name: "求职指南",
          children: null,
          id: "3",
        },
      ],
    };
  },
  computed: {
    // 我们使用计算属性来获取到当前点击的菜单的路由路径，然后设置default-active中的值
    // 使得菜单在载入时就能对应高亮
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // 可以在路由配置文件中设置自定义的路由路径到meta.activeMenu属性中，来控制菜单自定义高亮显示
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },

  methods: {
    handleSelect(item, i) {
      console.log(165, item, i);
      this.activeIndex = "" + i;

      this.$router.push({ path: item.path});

      // console.log(156, this.activeIndex);
    },
    exitLogin() {
      sessionStorage.removeItem("TOKEN");
      sessionStorage.removeItem("userData");
      this.$message.success("退出成功");
      window.location.href = "/";
    },
  },
  created() {
    console.log("判断用户信息是否存在,控制展示用户信息还是展示头像");
    this.userData = JSON.parse(sessionStorage.getItem("userData"));
    console.log("当前用户信息:", this.userData);
  },
};
</script>

<style scoped>
/* 功能靠右  */
.el-menu {
  float: right;
  margin-right: 0%;
  background-color: #fff;
}

a {
  text-decoration: none !important; /* 去掉下划线 */
}

/* 二级菜单a连接导致颜色错误修正 */
.funTwo {
  color: #85888e;
}

.funTwo:hover {
  color: #303133;
}
.el-row {
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  width: 100%;
  height: 80px;
  background-color: #fff;
  z-index: 99;
}
.grid-content {
  display: flex;
}
.grid-content .el-menu-demo li {
  display: flex;
  align-items: center;
  height: 80px;
  line-height: 80px;
}
.grid-content .el-menu-demo li a {
  border-radius: 4px;

  overflow: hidden;
  color: #303133;
  font-weight: 700;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
}
.el-menu--horizontal > .el-menu-item {
  height: 80px;
  line-height: 80px;
}
.menu-name {
  font-weight: 700;
  margin: 0 15px;
}
.router-name-active {
  color: #1890ff;
}

/*a:link {*/
/*    color: #909399 !important; !*未访问的链接颜色*!*/
/*}*/

/*a:visited {*/
/*    color: #0F180F !important; !*已访问的链接颜色*!*/
/*}*/

/*a:hover {*/
/*    color: #0f180f !important; !*鼠标移动到链接的颜色*!*/
/*    text-decoration: underline;*/
/*}*/

/*a:active {*/
/*    color: #ff6827 !important; !*鼠标点击时的颜色*!*/
/*}*/
</style>

